/**
 * Per-colour related-product upsell (snippets/product-upsell-block.liquid).
 *
 * Colours on the Nugget PDP are separate products swapped in client-side by
 * assets/collection-pdp-loader.js. This file listens to the same swatch clicks
 * independently — the upsell logic stays out of that loader so nothing else on the PDP can be
 * affected. Each colour that has a `custom.product_upsell_block` entry is pre-rendered into a
 * <script type="text/template"> keyed by its variant id; colours without one have no template,
 * so the block is simply removed.
 *
 * Add to cart is handled by the theme's delegated `.quick-add` listener (assets/theme.js), which
 * works on re-injected markup.
 */
(() => {
  const swapUpsell = (variantId) => {
    document.querySelectorAll('.js-product-upsell').forEach((container) => {
      container.querySelectorAll('.js-product-upsell-area').forEach((area) => area.remove());

      const template = container.querySelector(
        `script[type="text/template"][data-variant-id="${variantId}"]`
      );

      if (template) {
        container.insertAdjacentHTML('beforeend', template.innerHTML);
      }
    });
  };

  document.addEventListener('click', (evt) => {
    const swatch = evt.target.closest && evt.target.closest('.gg-product[data-product-id]');
    if (!swatch) return;

    const variantId = swatch.dataset.productId;
    // ponytail: digits-only guard keeps the id safe to interpolate into the selector below
    if (!/^\d+$/.test(variantId)) return;

    swapUpsell(variantId);
  });
})();
